import React from 'react'
import { Link } from "react-router-dom";
import { Helmet } from 'react-helmet';




function Public404() {
  return (



    <>
 <Helmet>
        <link rel="stylesheet" type="text/css" href="/main/css/style.css"></link>
        <link rel="stylesheet" type="text/css" href="/main/css/responsive.css"></link>
      </Helmet>

<div class="main-page-wrapper p0  bg-white">
 

   <div class="error-page d-lg-flex align-items-center">
      <div class="img-holder order-lg-last">
         <img src="/images/media/404.svg" alt="" class="w-100 illustration"/>
         <img src="/images/media/404-q.svg" alt="" class="shapes qus"/>
      </div>
      <div class=" theme-menu-one text-wrapper title-style-one mb-40 order-lg-first">
         <div class="logo-main"><Link to="/"><img src="https://taskflier.com/main/images/logo/mnb-project.png" className='w-100' alt=""/></Link></div>
         <h2 className='mt-5'>404 -  <br/>Page Not Found</h2>
        
         <p class="font-rubik">It looks like you’ve taken a wrong turn. This page is either missing, moved, or never existed.</p>
        

         <Link to="/" class="theme-btn-2 mt-10 mb-20">Visit - taskflier.com <i class="bi bi-arrow-right pl-2"></i></Link>
      </div>
    
   </div>

   <footer class="theme-footer-seven mt-0">
				<div class="lg-container">
					

					
						<div class="bottom-footer mt-0 px-3 pt-3">
							<div class="row">
								<div class="col-lg-4 order-lg-1 mb-2">
									<ul class="d-flex justify-content-center justify-content-lg-start footer-nav">
										<li><Link to="/terms-of-service" className="font-14 font-rubik">Terms of Service</Link></li>
										<li><Link to="/privacy-policy" className="font-14 font-rubik">Privacy Policy</Link></li>
									</ul>
								</div>
								<div class="col-lg-4 order-lg-3 mb-1">
                <p class="copyright text-right font-14 font-rubik ">© 2025, TaskFlier All Rights Reserved.</p>
								</div>
								<div class="col-lg-4 order-lg-2 mb-2">
									
								</div>
							</div>
						</div>
				
				</div>
				
			</footer>
  
</div>





    </>
    
  )
}

export default Public404